import defaultApi from '../../api/defaultApi';

const BASE_URL = '/custodias';

export const obtenerListadoCustodiaPorFecha = async (fecha, usuarioId) => {
    const response = await defaultApi.get(`${BASE_URL}/fecha-creacion`, { params: { fechaCreacion: fecha, usuarioId: Number(usuarioId) } });
    return response;
};

export const obtenerListaVehiculos = async () => {
    const response = await defaultApi.get(`/dispositivo/tipo/191/estado/Activo`);
    return response;
};

export const obtenerCustodiaTrazabilidad = async (custodiaId) => {
    const response = await defaultApi.get(`${BASE_URL}/historial/by-custodia`, { params: { custodiaId } });
    return response;
};

export const guardarPhotoTrazabilidad = async (file, id = null, custodiaId, descripcion, coords = null) => {
    const formData = new FormData();

    // Archivo obligatorio
    formData.append('file', file);

    // Parámetros como form fields (NO como query params)
    formData.append('custodiaId', custodiaId);
    formData.append('descripcion', descripcion.trim());

    if (id !== null && id !== undefined) {
        formData.append('id', id);
    }

    if (coords && coords.lat != null && coords.lng != null) {
        formData.append('latitud', coords.lat);
        formData.append('longitud', coords.lng);
    }

    return defaultApi.post('/custodias/historial/upload', formData);
};

export const guardarCustodia = async (custodiaData) => {
    const { hasClientId, estadoCode, ...rest } = custodiaData;
    const response = await defaultApi.post(BASE_URL, rest);
    return response;
};

export const obtenerCustodiaPorId = async (custodiaId) => {
    const response = await defaultApi.get(`${BASE_URL}/${custodiaId}`);
    return response;
};

export const loadEvidenciaComponentes = async (componenteId) => {
    const response = await defaultApi.get(`${BASE_URL}/evidencia/by-custodiado-componente`, {
        params: {
            custodiadoComponenteId: componenteId
        }
    });
    return response;
};

export const guardarEvidenciaComponente = async (file, id, custodiaId, tipoEvidencia, custodiadoComponenteId) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await defaultApi.post(`${BASE_URL}/evidencia/upload`, formData, {
        params: {
            id: id,
            custodiaId: custodiaId,
            tipoEvidencia: tipoEvidencia,
            custodiadoComponenteId: custodiadoComponenteId
        }
    });
    return response;
};

export const obtenerPersonaPorTipo = async (tipo) => {
    const response = await defaultApi.get(`/persona/tipo/${tipo}`);
    return response;
};

export const obtenerCustodiadoImagenes = async (origen, origenId) => {
    const response = await defaultApi.get(`/custodia-imagenes`, {
        params: {
            origen: Number(origen),
            origenId: origenId
        }
    });
    return response;
};

export const guardarEvidenciaCustodio = async (id, file, custodiaId, origen, origenId, tipo, descripcion) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await defaultApi.post(`/custodia-imagenes/upload`, formData, {
        params: {
            id: id,
            custodiaId: custodiaId,
            origen: origen,
            origenId: origenId,
            tipo: tipo,
            descripcion: descripcion
        }
    });
    return response;
};

export const validarEvidenciasCustodia = async (custodiaId, tipo) => {
    const response = await defaultApi.get(`${BASE_URL}/${custodiaId}/validar`, {
        params: {
            tipo: tipo
        }
    });
    return response;
};

// --- Validación de envío / retención por GPS ---

// Reenvío manual del reporte de cierre. Re-valida cobertura GPS.
// forzar=true envía igualmente si la retención es "forzable" (bajo el mínimo pero sobre el piso).
// Serializa arrays repitiendo la clave (excluir=1&excluir=2), que es lo que Spring
// bindea a List<Long>. axios 0.x exige que paramsSerializer sea una FUNCION (el
// objeto {indexes:null} es de axios 1.x y aca revienta antes de enviar el request).
const serializarParams = (params) => {
    const partes = [];
    Object.entries(params || {}).forEach(([clave, valor]) => {
        if (valor === undefined || valor === null) return;
        const lista = Array.isArray(valor) ? valor : [valor];
        lista.forEach((v) => partes.push(`${encodeURIComponent(clave)}=${encodeURIComponent(v)}`));
    });
    return partes.join('&');
};

// Reenvío del reporte. 'excluir' son los dispositivoId que el supervisor desmarcó:
// no se validan ni salen en el reporte. Si no queda ninguno marcado el backend
// responde sinEquipos=true y no envía (solo se puede descargar).
export const reenviarReporteCustodia = async (custodiaId, forzar = false, excluir = []) => {
    const response = await defaultApi.post(`${BASE_URL}/${custodiaId}/reenviar-reporte`, null, {
        params: { forzar, excluir: excluir.length ? excluir : undefined },
        paramsSerializer: serializarParams
    });
    return response;
};

// Descarga manual del PDF (aplica los equipos desmarcados). Salida cuando no se
// puede enviar al cliente, p. ej. ningún GPS con datos.
export const descargarReporteCustodia = async (custodiaId, excluir = []) => {
    const response = await defaultApi.get(`${BASE_URL}/${custodiaId}/descargar-reporte`, {
        params: { excluir: excluir.length ? excluir : undefined },
        paramsSerializer: serializarParams,
        responseType: 'blob'
    });
    return response;
};

// Validar estatus de un dispositivo antes de asignarlo (usar / no usar).
export const validarEstatusDispositivo = async (dispositivoId) => {
    const response = await defaultApi.get(`${BASE_URL}/dispositivo/${dispositivoId}/validar-estatus`);
    return response;
};

// --- Configuración (correos del aviso interno + parámetros) ---

const CONFIG_URL = '/custodia-envio-config';

export const obtenerConfigEnvio = async () => {
    const response = await defaultApi.get(CONFIG_URL);
    return response;
};

export const guardarConfigEnvio = async (config) => {
    const response = await defaultApi.put(CONFIG_URL, config);
    return response;
};

export const listarCorreosNotificacion = async () => {
    const response = await defaultApi.get(`${CONFIG_URL}/correos`);
    return response;
};

export const guardarCorreoNotificacion = async (correo) => {
    const response = await defaultApi.post(`${CONFIG_URL}/correos`, correo);
    return response;
};

export const eliminarCorreoNotificacion = async (id) => {
    const response = await defaultApi.delete(`${CONFIG_URL}/correos/${id}`);
    return response;
};
